/**
 * CATEGORY tree backend error mappings.
 *
 * The three tree mutations (create, rename, move) refuse a name already taken by
 * a sibling. The backend answers 409 (405 before TT-7351, still accepted while
 * both versions are deployed) with a message the user cannot act on.
 */

const CATEGORY_APIS = ['addNewCategory', 'editCategory', 'category/parent'];

const NAME_TAKEN = {
  en: 'A category named “{name}” already exists at this level. Pick another name.',
  fr: 'Une catégorie « {name} » existe déjà à cet endroit. Choisissez un autre nom.',
};

const NAME_TAKEN_UNNAMED = {
  en: 'A category with this name already exists at this level. Pick another name.',
  fr: 'Une catégorie portant ce nom existe déjà à cet endroit. Choisissez un autre nom.',
};

const NAME_EMPTY = {
  en: 'A category name cannot be empty.',
  fr: 'Le nom de la catégorie ne peut pas être vide.',
};

const CONFLICT_STATUSES = [409, 405];

export function isCategoryApi(api) {
  return typeof api === 'string' && CATEGORY_APIS.includes(api);
}

function isNameConflict(error) {
  return (
    CONFLICT_STATUSES.includes(error?.status) &&
    String(error?.message || '').includes('same category name')
  );
}

function isEmptyName(error) {
  return (
    error?.status === 400 && String(error?.message || '').includes('name can not be empty')
  );
}

/**
 * `name` is the label the user typed, trimmed the way the backend trims it before
 * comparing, so the message quotes what was actually tested.
 */
export function resolveCategoryErrorMessage({error, locale = 'fr', name} = {}) {
  const normalizedLocale = locale === 'en' ? 'en' : 'fr';
  if (isEmptyName(error)) return NAME_EMPTY[normalizedLocale];
  if (!isNameConflict(error)) return null;

  const typed = String(name ?? '').trim();
  if (!typed) return NAME_TAKEN_UNNAMED[normalizedLocale];
  return NAME_TAKEN[normalizedLocale].replace('{name}', typed);
}
